import React, { useContext, useEffect, useState } from "react";
import { Alert, Dialog, Table } from "../../../layout";
import { Button } from "../../../controls";
import { IconButton, Tooltip } from "@mui/material";
import { ClearRounded, EditRounded } from "@mui/icons-material";
import AddEditType from "./AddEditInqSrc";
import { API, actions, endpoints } from "../../../api/api";
import { AppContext } from "../../../App";
import { useTranslation } from "react-i18next";

const InqSrcs = () => {
  const { t } = useTranslation();
  const [updData, setUpdData] = useState();
  const [showForm, setShowForm] = useState(false);
  const { branch, setLoader } = useContext(AppContext);
  const [types, setTypes] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const handleAddEdit = (data) => {
    setUpdData(data);
    setShowForm(true);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: t("CfmTitle"),
      subTitle: t("InqDltTitle"),
      onConfirm: () => {
        const onComplete = (res) => {
          if (res && res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: t("DltSuccessTitle"),
              subTitle: res.msg,
            });
            setTypes((x) => [...x.filter((j) => j.id !== res.result.id)]);
          } else if (res) {
            setAlert({
              isOpen: true,
              type: "warning",
              title: t("Warning"),
              subTitle: res.msg,
            });
          }
        };
        API(endpoints.InqSrc).Delete(id, onComplete);
      },
    });
  };

  useEffect(() => {
    setLoader(true);
    if (branch.id) {
      API(endpoints.InqSrc + actions.GetAllByBranch).getById(
        branch.id,
        (res) => {
          res.status === 200 && setTypes([...res.result]);
          setLoader(false);
        }
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  const ActionComp = (val) => (
    <div className="bs-secondary br-8 w-fit">
      <Tooltip title={t("Edit")}>
        <IconButton
          onClick={() => handleAddEdit(val)}
          size="small"
          color="primary"
          className="mr-5 p-5"
        >
          <EditRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
      <Tooltip title={t("Delete")}>
        <IconButton
          onClick={() => handleDlt(val.id)}
          size="small"
          color="error"
          className="mr-5 p-5"
        >
          <ClearRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
    </div>
  );

  const HeaderComp = () => (
    <div>
      <Button onClick={() => handleAddEdit()}>{t("AddInquirySource")}</Button>
    </div>
  );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "name", label: t("InquirySrouceName") },
          { id: "userName", label: t("AddedUser") },
          { id: "addDate", label: t("AddedDate") },
          { id: "updateDate", label: t("LastUpdateDate") },
          { id: "actions", label: t("Actions") },
        ]}
        tblData={types.map((j) => ({
          ...j,
          userName: j.addedUser && j.addedUser.firstName,
        }))}
      />

      {/* Add Follow Up */}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="sm">
          <AddEditType
            {...{ setShowForm: setShowForm, updData, setTypes, setAlert }}
          />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default InqSrcs;
